import React from 'react';
import StyledBox from 'views/rebranded-module/location-module/LocationsViewV2/components/LocationsParticipating/LocationsParticipating.styles';
import { Container } from '@mui/material';
import PATHS from 'lib/navigation/paths';
import NavigatorLink from 'views/rebranded-module/common/components/Logical/NavigatorLink';
import { Typography700 } from 'views/rebranded-module/common/components';

const LocationsParticipating = (props) => {
  const { content } = props;

  return (
    <Container maxWidth="xl">
      <StyledBox>
        <NavigatorLink href={PATHS.motorcycleClub.index()} className="LPChip">
          <Typography700
            variant="overline2"
            component="span"
            className="LPLable">
            {content.clubEaglerider}
          </Typography700>
        </NavigatorLink>
        <Typography700
          variant="overline1"
          component="span"
          className="LPParticipateText">
          {content.locationParticipating}
        </Typography700>
      </StyledBox>
    </Container>
  );
};

export { LocationsParticipating };
